if (!customElements.get('content-tabs')) {
    class ContentTabs extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            setTimeout(() => {
                this.elSection = this.closest('section');
                this.elTabs = this.querySelectorAll('[data-tab]');
                this.elPanels = this.querySelectorAll('[data-panel]');

                this.elDefaultPanel = [...this.elPanels].find(el => el.hasAttribute('data-default-panel'));

                const initialTab = [...this.elTabs].find(el => el.getAttribute('aria-selected') === 'true') || this.elTabs[0];

                this.activePanel = initialTab ? initialTab.getAttribute('aria-controls') : null;
                this.activeIndex = [...this.elPanels].map(el => el.id).indexOf(this.activePanel);

                this.style.setProperty('--selected', this.activeIndex);

                for (const el of this.elTabs) {
                    el.addEventListener('click', this.#handleClick.bind(this));
                    el.addEventListener('keydown', this.#handleKeydown.bind(this));
                }
            });
        }

        #handleClick({ currentTarget }) {
            const clickedPanel = currentTarget.getAttribute('aria-controls');
            const isAlreadyActive = currentTarget.getAttribute('aria-selected') === 'true';

            // Preserve legacy behavior: clicking the currently-active non-default tab
            // falls back to the default panel rather than no-op.
            const targetPanel = isAlreadyActive && this.elDefaultPanel && clickedPanel !== this.elDefaultPanel.id
                ? this.elDefaultPanel.id
                : clickedPanel;

            this.#activatePanel(targetPanel);
        }

        #handleKeydown(event) {
            const tabs = [...this.elTabs];
            const currentIndex = tabs.indexOf(event.currentTarget);

            const nextIndex = (() => {
                switch (event.key) {
                    case 'ArrowRight': return (currentIndex + 1) % tabs.length;
                    case 'ArrowLeft': return (currentIndex - 1 + tabs.length) % tabs.length;
                    case 'Home': return 0;
                    case 'End': return tabs.length - 1;
                    default: return -1;
                }
            })();

            if (nextIndex < 0) return;

            event.preventDefault();
            const nextTab = tabs[nextIndex];
            nextTab.focus({ preventScroll: true });
            this.#activatePanel(nextTab.getAttribute('aria-controls'));
        }

        #activatePanel(panelId) {
            for (const el of this.elTabs) {
                const isActive = el.getAttribute('aria-controls') === panelId;
                el.setAttribute('aria-selected', isActive ? 'true' : 'false');
                el.setAttribute('tabindex', isActive ? '0' : '-1');
            }

            this.classList.add('loading');

            this.activePanel = panelId;
            this.activeIndex = [...this.elPanels].map(el => el.id).indexOf(panelId);
            this.style.setProperty('--selected', this.activeIndex);

            setTimeout(() => {
                for (const el of this.elPanels) {
                    const isActive = el.id === panelId;
                    el.classList.toggle('is-active', isActive);
                    el.setAttribute('tabindex', isActive ? '0' : '-1');

                    if (isActive) {
                        el.removeAttribute('aria-hidden');
                    } else {
                        el.setAttribute('aria-hidden', 'true');
                    }
                }
            }, 300);

            setTimeout(() => {
                this.classList.remove('loading');
            }, 600);
        }
    }

    customElements.define('content-tabs', ContentTabs);
}
